import React from 'react';
import { document } from '../helpers/BrowserHelpers';
var EVENT_MAP = {
  onBeforeInput: 'beforeinput',
  onBlur: 'blur',
  onClick: 'click',
  onCompositionEnd: 'compositionend',
  onCompositionStart: 'compositionstart',
  onContextMenu: 'contextmenu',
  onCopy: 'copy',
  onCut: 'cut',
  onDragEnd: 'dragend',
  onDragEnter: 'dragenter',
  onDragExit: 'dragexit',
  onDragLeave: 'dragleave',
  onDragOver: 'dragover',
  onDragStart: 'dragstart',
  onDrop: 'drop',
  onFocus: 'focus',
  onInput: 'input',
  onKeyDown: 'keydown',
  onKeyUp: 'keyup',
  onMouseDown: 'mousedown',
  onMouseUp: 'mouseup',
  onPaste: 'paste',
  onSelect: 'select'
};
var SUPPORTED_EVENTS = Object.keys(EVENT_MAP);

function DocumentEventListener(props) {
  React.useEffect(function () {
    SUPPORTED_EVENTS.forEach(function (event) {
      if (!props[event]) return;
      document.addEventListener(EVENT_MAP[event], props[event]);
    });
    return function () {
      SUPPORTED_EVENTS.forEach(function (event) {
        if (!props[event]) return;
        document.removeEventListener(EVENT_MAP[event], props[event]);
      });
    };
  }, [props]);
  return false;
}

export default React.memo(DocumentEventListener);